import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ad61d6de"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "divDzqm"
};
const _hoisted_2 = {
  id: "canvas",
  ref: "signatureCanvas",
  width: "480",
  height: "260"
};
const _hoisted_3 = {
  class: "divButton"
};
const _hoisted_4 = /*#__PURE__*/_createTextVNode("清除");
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("canvas", _hoisted_2, null, 512)]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.clearSignature
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.saveSignature
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }, 8, ["onClick"])])]);
}